var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbnailPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "thumbnail-placeholder",
    width: "328px",
    height: "185px",
    viewBox: "0 0 328 185",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "thumbnail-placeholder-1",
    x: 0,
    y: 0,
    width: 328,
    height: 185
  }), /*#__PURE__*/React.createElement("path", {
    id: "thumbnail-placeholder-2",
    d: "M26.2677851,28.125 L30.9325,32.76375 L48.73125,32.76375 L53.3979126,28.125 L71.875,28.125 L71.875,71.875 L8.125,71.875 L8.125,28.125 L26.2677851,28.125 Z M66.25,18.75 L66.25,22.5 L13.75,22.5 L13.75,18.75 L66.25,18.75 Z M60,11.25 L60,15 L20,15 L20,11.25 L60,11.25 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "thumbnail-placeholder-3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "thumbnail-placeholder-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "thumbnail-placeholder-5"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "thumbnail-placeholder-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    id: "thumbnail-placeholder-7",
    xlinkHref: "#thumbnail-placeholder-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "thumbnail-placeholder-8",
    fill: "#151515",
    xlinkHref: "#thumbnail-placeholder-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "thumbnail-placeholder-9",
    mask: "url(#thumbnail-placeholder-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "thumbnail-placeholder-10",
    transform: "translate(124.000000, 53.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "thumbnail-placeholder-11",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    id: "thumbnail-placeholder-12",
    xlinkHref: "#thumbnail-placeholder-2"
  })), /*#__PURE__*/React.createElement("use", {
    id: "thumbnail-placeholder-13",
    stroke: "none",
    fill: "#151515",
    fillRule: "nonzero",
    xlinkHref: "#thumbnail-placeholder-2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "thumbnail-placeholder-14",
    stroke: "none",
    fill: "none",
    mask: "url(#thumbnail-placeholder-11)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "thumbnail-placeholder-15",
    fill: "#737373",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnailPlaceholder);
export default __webpack_public_path__ + "static/media/thumbnail-placeholder.8838c1463c780e77ad79314735263bdb.svg";
export { ForwardRef as ReactComponent };